import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Box, Typography } from '@mui/material';
import CreateQuery from '../createQuery';
import { CustomSelect, CustomButton, CustomCalendar, CustomModal, CustomReactSelect } from '../../../shared';
import { PlusIcon, Trash, CalendarIcon } from '../../../../assets';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../redux/reducers/queriesReducer';
import { deleteQuery } from '../../../../redux/thunks/triggerThunk';
import ConfirmationModal from '../../../shared/confirmationModal';
import ConfirmationDelete from '../confirmationDelete';
import { actions as companyActions } from '../../../../redux/reducers/companyReducer';


const FilterBar = (props) => {
    const navigate = useNavigate();
    const { showModal, selected } = useSelector(state => state.query);
    const [open, setOpen] = useState(false);
    const { companyOptions, company: selectedCompany } = useSelector((state) => state.company);
    const dispatch = useDispatch()
    const { setCompany } = companyActions;
    
    const handleCompanyChange = (option) => {
        dispatch(setCompany(option));
    };


    const handleDeleteSelected = () => {
        if(selected.length>0){
            dispatch(deleteQuery({companyId: selectedCompany.id, data: {ids: selected}})).then(result => {
                if(result.payload.status_code === 200){
                    dispatch(actions.setSelectAllFalse())
                    onclose();
                }
            })
        }
    };

    const onclose = () =>{
        setOpen(!open)
    };
   
    return (
        <>
             <Grid className="flex-row-space-between pb-24px mt-10px">
                <Grid className='d-flex gap-12' xs={6}>
                    {/* Select Inputs */}
                    <Box className="flex-row gap-12"> 
                        <Box width={300}>
                            <CustomReactSelect
                                options={companyOptions}
                                handleFilter={handleCompanyChange}
                                selectedOption={{
                                    label: selectedCompany.name,
                                    value: selectedCompany.id,
                                }}
                                customStyle={{ borderRadius: '50px' }}
                                placeholder="Select Company"
                            />
                        </Box>
                    </Box>
                </Grid>
                <Grid xs={6} className='d-flex gap-12'>
                    <CustomButton
                        title="Create New"
                        titleColor="#FFFFFF"
                        buttonColor="#AD509E"
                        icon={<PlusIcon color='#FFFFFF' />}
                        handleClick={()=>dispatch(actions.handleQueryModal({title: "Create new query"}))}
                    />
                    <CustomButton
                        title="Delete Queries"
                        icon={<Trash />}
                        handleClick={()=> setOpen(true)}
                    />
                </Grid>
            </Grid>
            <CustomModal 
                modalOpen={showModal} 
                component={<CreateQuery handleClose={()=>dispatch(actions.handleQueryModal({title: ""}))} />}
                onClose={()=>dispatch(actions.handleQueryModal({title: ""}))}
            />
           <ConfirmationDelete open={open} onClosed={onclose} onConfirms={handleDeleteSelected}/>
        </>
    );
};

export default FilterBar;
